<div
  class="text-center h-100 cursor-pointer item-card shadow-sm"
  [ngClass]="isActive ? 'main-color' : 'border-light'"
>
  <img
    [src]="site.image"
    class="card-img-top"
    [alt]="site.name"
    loading="lazy"
  />
  <div class="card-body p-2">
    <h6 class="card-title mb-0">{{ site.name }}</h6>
  </div>
</div>
